module.exports = __webpack_public_path__ + "static/add.b4034dea.png";